import { useEffect, useState } from "react";
import { db } from "../../../firebase";
import { ref, push, set } from "firebase/database";
import { Await, useLocation, useNavigate } from "react-router-dom";
import { createSong, deleteSong, upsertSong } from "../utility/getSongsPage";
import { AiOutlineClose } from "react-icons/ai";
import { KannadaText,TamilText } from "../components/KannadaText";
import toast from "react-hot-toast";

function SongCE() {

  const {state,pathname} = useLocation()
  const navigate = useNavigate()

  const path = pathname?.split('/').at(-1)

  console.log("path",path)

  console.log("state",state)
  const [data, setdata] = useState({
    titleEN: "",
    titleKAN: "",
    titleTAM: "",
    song_num: "",
    keywords: [""],
    lyricsKAN: [""],
    lyricsTAM: [""],
  });

  useEffect(()=>{
    if(path == 'edit'){
        setdata({
            titleEN: state?.titleEN,
            titleKAN: state?.titleKAN,
            titleTAM: state?.titleTAM,
            song_num: state?.song_num,
            keywords: state?.keywords,
            lyricsKAN: state?.lyricsKAN,
            lyricsTAM: state?.lyricsTAM,
        })
    }

  },[pathname])

  const [saving, setSaving] = useState(false);

  function updateField(field, value) {
    setdata({ ...data, [field]: value });
  }

  function updateArray(field, index, value) {
    const arr = [...data[field]];
    arr[index] = value;
    setdata({ ...data, [field]: arr });
  }

  function addArrayItem(field) {
    setdata({ ...data, [field]: [...data[field], ""] });
  }

  function removeArrayItem(field, index) {
    const arr = data[field].filter((_, i) => i !== index);
    setdata({ ...data, [field]: arr });
  }

  // FINAL JSON FORMAT (same as you shared)
  const songJson = {
    // [data.titleEN]: {
      keywords: data.keywords.filter((k) => k.trim()),
      lyricsKAN: data.lyricsKAN.filter((l) => l.trim()),
      lyricsTAM: data.lyricsTAM.filter((l) => l.trim()),
      song_num: Number(data.song_num),
      titleEN: data.titleEN,
      titleKAN: data.titleKAN,
      titleTAM: data.titleTAM,
    // },
  };

  // SAVE TO FIREBASE
  async function saveToFirebase() {
    if (!data.titleEN) {
      alert("English Title is required!");
      return;
    }

    setSaving(true);

    try {
      const parentRef = ref(db, "songs");
      const newRef = push(parentRef); // auto insert
      
      if(path == 'edit'){
       await createSong(songJson)
      }else{
        await upsertSong(state?.titleEN,songJson)

      }
      toast.success(path === "edit" ? "Song updated!" : "Song created!");
      setdata({
        titleEN: "",
        titleKAN: "",
        titleTAM: "",
        song_num: "",
        keywords: [""],
        lyricsKAN: [""],
        lyricsTAM: [""],
      });
      if(path === 'edit'){
        navigate(-1)
      }
    } catch (err) {
      console.error(err);
      alert("Error saving song.");
    }

    setSaving(false);
  }


  async function deleteSongFromFirebase() {
    try {
      await deleteSong(data?.titleEN);
      navigate(-1)
      toast.success("Song deleted successfully");
    } catch (err) {
      toast.error("Delete failed");
    }
  }

  return (
    <div className="mx-auto mb-10 break-all">
  <div className="border-b mt-4 my-2">
    <h2 className="font-[700] text-[14px] pb-2">
      {path === "edit" ? "Update" : "Create"} Song
    </h2>
  </div>

  <div className="md:min-w-[50%] md:max-w-[50%] md:border-r pr-4 mr-4">
    {/* Title English */}
    <h6 className="text-[11px] font-[600] mb-1">Title (English)</h6>
    <input
      className="border p-[4px] focus:outline-none text-[14px] w-full mb-3"
      value={data.titleEN}
      onChange={(e) => updateField("titleEN", e.target.value)}
    />

    {/* Title Kannada */}
    <h6 className="text-[11px] font-[600] mb-1">Title (Kannada)</h6>
    <input
      className="border p-[4px] focus:outline-none text-[14px] w-full mb-3"
      value={data.titleKAN}
      onChange={(e) => updateField("titleKAN", e.target.value)}
    />

    {/* Title Tamil */}
    <h6 className="text-[11px] font-[600] mb-1">Title (Tamil)</h6>
    <input
      className="border p-[4px] focus:outline-none text-[14px] w-full mb-3"
      value={data.titleTAM}
      onChange={(e) => updateField("titleTAM", e.target.value)}
    />

    {/* Song Number */}
    <h6 className="text-[11px] font-[600] mb-1">Song Number</h6>
    <input
      type="number"
      className="border p-[4px] focus:outline-none text-[14px] w-full mb-3"
      value={data.song_num}
      onChange={(e) => updateField("song_num", e.target.value)}
    />

    {/* Keywords */}
    <div className="mb-4 relative">
      <label className="text-[11px] font-[900] mb-1">Keywords</label>
      <div className="flex flex-wrap">
        {data.keywords.map((k, i) => (
          <div key={i} className="border flex items-center mr-1 gap-2 mt-1">
            <input
              className="p-[4px] focus:outline-none text-[13px]"
              value={k}
              onChange={(e) => updateArray("keywords", i, e.target.value)}
            />
            <button
              className="p-2 -ml-[10px] bg-red-500 text-white"
              onClick={() => removeArrayItem("keywords", i)}
            >
              <AiOutlineClose size={12} />
            </button>
          </div>
        ))}
      </div>

      <button
        className="mt-2 absolute top-[-4px] right-0 text-[11px] p-[2px] px-[10px] bg-slate-200 text-slate-700 font-[600] rounded"
        onClick={() => addArrayItem("keywords")}
      >
        <h6 className="pt-1">+ Add Keyword</h6>
      </button>
    </div>

    {/* Lyrics Kannada */}
    <div className="mb-4">
      <label className="text-[13px] font-[900] mb-1">Lyrics (Kannada)</label>
      {data.lyricsKAN.map((l, i) => (
        <div key={i} className="border flex gap-2 mt-1">
          <input
            className="p-[4px] focus:outline-none text-[14px] w-full"
            value={l}
            onChange={(e) => updateArray("lyricsKAN", i, e.target.value)}
          />
          <button
            className="p-2 flex items-center justify-center -ml-[10px] bg-red-500 text-white w-[40px]"
            onClick={() => removeArrayItem("lyricsKAN", i)}
          >
            <AiOutlineClose size={12} />
          </button>
        </div>
      ))}

      <button
        className="mt-2 text-[12px] px-4 py-1 bg-green-600 text-white rounded"
        onClick={() => addArrayItem("lyricsKAN")}
      >
        <h6 className="pt-1">+ Add KAN Line</h6>
      </button>
    </div>

    {/* Lyrics Tamil */}
    <div className="mb-4">
      <label className="text-[13px] font-[900] mb-1">Lyrics (Tamil)</label>
      {data.lyricsTAM.map((l, i) => (
        <div key={i} className="border flex gap-2 mt-1">
          <input
            className="p-[4px] focus:outline-none text-[14px] w-full"
            value={l}
            onChange={(e) => updateArray("lyricsTAM", i, e.target.value)}
          />
          <button
            className="p-2 flex items-center justify-center -ml-[10px] bg-red-500 text-white w-[40px]"
            onClick={() => removeArrayItem("lyricsTAM", i)}
          >
            <AiOutlineClose size={12} />
          </button>
        </div>
      ))}

      <button
        className="mt-2 text-[12px] px-4  py-1 bg-green-600 text-white rounded"
        onClick={() => addArrayItem("lyricsTAM")}
      >
       <h6 className="pt-1">+ Add TAM Line</h6> 
      </button>
    </div>

    {/* Buttons */}
    <div className="flex items-center gap-2 mt-4">
      <button
        onClick={saveToFirebase}
        disabled={saving}
        className="bg-[#7b026b] text-[12px] font-[500] text-white px-2 py-1 rounded"
      >
        <h6 className="pt-1">{saving ? "Saving..." : "Save Song to Firebase"}</h6>
      </button>

      {path === "edit" && (
        <button
          onClick={deleteSongFromFirebase}
          className="bg-red-600 text-[12px] font-[500] text-white px-2 py-1 rounded"
        >
          <h6 className="pt-1">Delete Song</h6>
        </button>
      )}
    </div>

    {/* JSON Output */}
    <h3 className="font-bold mt-4 ">Generated JSON</h3>
    <pre className="bg-gray-100 p-4 break-word rounded mt-2 text-sm">
      {JSON.stringify(songJson, null, 2)}
    </pre>
{/* 
    <KannadaText>
      {data?.titleKAN}
    </KannadaText>

    <TamilText>
      {data?.titleTAM}
    </TamilText> */}
   
  </div>
    </div>
  );
}

export default SongCE;
